import type { ComponentProps } from 'react'
import { FileClock } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { ConfigChangesPage } from './admin/ConfigChangesPage.js'

type Api = ComponentProps<typeof ConfigChangesPage>['api']

/** What the audit module contributes to the shells: the root's configuration history, beside its sign-in history. */
export const auditWebModule: WebModule<Api> = {
  name: 'audit',
  adminPages: [
    { path: '/admin/config-changes', label: 'Config changes', title: 'Configuration History', icon: FileClock, group: 'system', rootOnly: true, page: ({ api }) => <ConfigChangesPage api={api} /> },
  ],
}
